const Component = ({
  value,
  onChange,
  customCurrencyOptions,
  disabled,
  className,
  style,
}) => {
  const selectStyle = {
    border: '1px solid #dbdfea',
    borderRadius: '5px',
    padding: '5px',
  };

  const baseCurrencyOptions = customCurrencyOptions
    ? customCurrencyOptions
    : [
        { value: 'USDC', label: 'USDC' },
        { value: 'USDT', label: 'USDT' },
        { value: 'ETH', label: 'ETH' },
        { value: 'BTC', label: 'BTC' },
      ];
  const currencyOptions =
    value && !baseCurrencyOptions.some((option) => option.value === value)
      ? [{ value, label: value }, ...baseCurrencyOptions]
      : baseCurrencyOptions;

  return (
    <select
      value={value || ''}
      onChange={onChange}
      className={className}
      style={{ ...selectStyle, ...style }}
      disabled={disabled}
    >
      {currencyOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default Component;
